module.exports = __webpack_public_path__ + "img/HU12399596.1aafdccd.png";